import React, { useState } from "react";
import PropTypes from "prop-types";
import { red, grey } from "@mui/material/colors";
import { notification } from "../../../utils/Notifications";
import { getUsers } from "../../../api/userApi";
import { changeUserStatus } from "../../../api/userApi";
import { useNavigate } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { removeAccessToken } from '../../../store/reducers/auth/authReducer.js';
import { removeCookie } from '../../../utils/CookiesUtil.js'
import useLogout from '../../../hooks/auth/authHook.js';
import {
  Button,
  CircularProgress,
  Container,
  Dialog,
  Typography,
} from "@mui/material";

UsersDeleteConfirmationDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default function UsersDeleteConfirmationDialog({ onClose, open, user, fetchUsers }) {
  const [logout] = useLogout();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(false);

  const handleDialogClose = (event, reason) => {
    if (reason === "backdropClick") {
      return;
    }
    onClose();
  };

  const deleteUser = () => {
    if (isLoading) {
      return;
    }
    setIsLoading(true);
    changeUserStatus(user.id)
      .then((response) => {
        if (response.status === 200 && response.data.status_Message === "state was changed successfully") {
          getUsers()
            .then((response) => {
              if (response.status === 200) {
                notification({ text: "Usuario desactivado", type: "success" });
                fetchUsers();
              } else if (response.status === 401) {
                notification({
                  text: "Sesión expirada. Por favor, inicia sesión nuevamente.",
                  type: "error",
                });
                logout();
              } else {
                notification({
                  text: response.data.status_Message || "Error al cambiar el estatus del usuario",
                  type: "error",
                });
              }
            })
            .catch((error) => {
              notification({text: 'Error de conexión, revisa tu conexión a internet', type: 'error'});
            });
            onClose();
        } else if (response.status === 401) {
          notification({
            text: "Sesión expirada. Por favor, inicia sesión nuevamente.",
            type: "error",
          });
          dispatch(removeAccessToken());
          removeCookie('accessToken');
          navigate('/login');
        } else {
          notification({
            text: response.data.status_Message || "Error al cambiar el estatus del usuario",
            type: "error",
          });
        }
      })
      .catch((error) => {
        notification({text: 'Error de conexión, revisa tu conexión a internet', type: 'error'});
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <Dialog
      onClose={handleDialogClose}
      open={open}
      PaperProps={{ style: { borderRadius: "16px" } }}
    >
      <Container style={{ padding: 26 }}>
        <Typography
          component="div"
          variant="h5"
          style={{
            textAlign: "center",
            fontWeight: "bold",
            color: grey[800],
            marginBottom: 12,
          }}
        >
          Desactivar usuario
        </Typography>
        <Typography
          component="div"
          variant="body1"
          style={{ textAlign: "center", color: grey[800], marginBottom: 0 }}
        >
          El usuario {user?.name} será desactivado
        </Typography>
        <Typography
          component="div"
          variant="body1"
          style={{ textAlign: "center", color: grey[800], marginBottom: 26 }}
        >
          ¿Deseas continuar?
        </Typography>
        <Container
          style={{
            display: "flex",
            width: "100%",
            padding: 0,
            marginTop: 16,
            gap: 12,
          }}
        >
          <Button
            variant="outlined"
            color="primary"
            onClick={() => {
              onClose();
            }}
            style={{
              width: "100%",
              borderRadius: "0.5rem",
              height: "38px",
              color: red["A400"],
              backgroundColor: red["50"],
            }}
          >
            Cancelar
          </Button>
          <Button
            variant="contained"
            onClick={() => deleteUser()}
            style={{
              width: "100%",
              borderRadius: "0.5rem",
              height: "38px",
              backgroundColor: red["A400"],
            }}
          >
            {isLoading ? (
              <CircularProgress size={24} style={{ color: "white" }} />
            ) : (
              "Desactivar"
            )}
          </Button>
        </Container>
      </Container>
    </Dialog>
  );
}
